import React from 'react';
import BilanIconButton from './BilanIconButton';

interface OrangeTriangleButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function OrangeTriangleButton({ onClick }: OrangeTriangleButtonProps) {
  return (
    <BilanIconButton
      aria-label="Ouvrir le bilan avec anomalie"
      iconType="warning"
      onClick={onClick}
      size="xs"
      variantType="primary"
    />
  );
}
